<div class="flex-1 w-full flex flex-col min-h-0">
  <!-- Comments List - Scrollable -->
  <div class="flex-1 min-h-0 overflow-y-auto -mr-2 pr-2">
    <ul #commentsContainer class="min-h-full flex flex-col gap-5 py-1">
      @for(comment of comments; track comment.id) {
        <li class="flex gap-3">
          <!-- Avatar -->
          <div class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-[10px] font-bold shrink-0 mt-0.5 shadow-sm">
            {{ getEmployeeInitials(comment.createdBy) }}
          </div>
          <!-- Body -->
          <div class="flex-1 min-w-0">
            <div class="flex items-baseline gap-2 mb-1">
              <span class="text-sm font-semibold text-gray-800 truncate">{{ getEmployeeName(comment.createdBy) }}</span>
              <span class="text-[11px] text-gray-400 shrink-0">{{ comment.createdAt | date:'dd MMM, HH:mm' }}</span>
            </div>
            <div class="bg-gray-50 border border-gray-100 rounded-2xl rounded-tl-sm px-3.5 py-2.5">
              <div class="text-sm text-gray-700 break-words leading-relaxed prose" [innerHTML]="comment.content"></div>
            </div>
          </div>
        </li>
      }
      @empty {
        <li class="flex-1 flex flex-col items-center justify-center text-center px-4">
          <div class="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-3">
            <svg class="w-7 h-7 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
            </svg>
          </div>
          <p class="text-sm font-medium text-gray-600">No comments yet</p>
          <p class="text-xs text-gray-400 mt-1">Be the first to leave a comment</p>
        </li>
      }
    </ul>
  </div>

  <!-- Comment Composer - pinned at bottom -->
  <div class="shrink-0 pt-3 mt-3 border-t border-gray-100 relative">
    <app-rich-text-editor
      #commentEditor
      [(ngModel)]="newCommentText"
      (ngModelChange)="onCommentInputChange()"
      (keydown)="onKeyDown($event)"
      placeholder="Write a comment..."
      heightClass="min-h-[80px]">
    </app-rich-text-editor>

    <!-- Bottom bar: hint + send -->
    <div class="flex items-center justify-between gap-2 mt-2 px-1">
      <span class="inline-flex items-center gap-1 text-[11px] text-gray-400">
        <span class="font-semibold text-gray-500">@</span> to mention
      </span>
      <button
        class="inline-flex items-center gap-1.5 bg-blue-600 text-white px-3.5 py-1.5 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-semibold text-xs shadow-sm cursor-pointer shrink-0"
        [disabled]="isCommentEmpty"
        (click)="addComment()">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
        </svg>
        Send
      </button>
    </div>

    <!-- Mentions Dropdown -->
    @if(showMentions) {
      <ul role="listbox" class="absolute bottom-full left-0 mb-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-hidden max-h-52 overflow-y-auto p-1">
        @for(emp of filteredEmployees; track emp.id; let i = $index) {
          <li role="option"
            [attr.aria-selected]="i === selectedIndex"
            (click)="selectMention(emp)"
            class="px-2 py-2 cursor-pointer flex items-center gap-3 rounded-lg transition-colors"
            [class.bg-blue-50]="i === selectedIndex"
            [class.hover:bg-gray-50]="i !== selectedIndex">
            <div class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center text-[10px] font-bold shrink-0">
              {{ emp.firstName!.charAt(0) }}{{ emp.name!.charAt(0) }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-gray-800 truncate">{{ emp.firstName }} {{ emp.name }}</div>
              <div class="text-xs text-gray-500 truncate">{{ emp.email }}</div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</div>
